import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import DialogWrapper from '../../components/dialog/Dialog';
import {Roles} from '../../constants/enums';
import {isMobile} from '../../utils/screenUtility';
import ChatButton from './ChatButton';
import './styles.scss';

@inject('manageStore')
@observer
class StudentChatDialog extends Component {
    handleClick = () => {
        this.props.onClose();
    };

    render() {
        const {onClose, open, manageStore} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'student-chat-modal-root', paper: 'paper'},
            open: open,
            onExited: onClose,
            onClose: onClose
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="student-chat-modal">
                    <button className="student-chat-modal-close" onClick={onClose}>
                        <Close/>
                    </button>
                    <h3><FormattedMessage id="messenger.dialog.title"/></h3>
                    <p><FormattedMessage id="messenger.dialog.description"/></p>
                    <div className="student-chat-modal-buttons">
                        {manageStore.teachersList.map(teacher => {
                            if (teacher.role !== Roles.Teacher && teacher.role !== Roles.SchoolAdmin) {
                                return null;
                            }
                            return <ChatButton
                                key={teacher.id}
                                teacher={teacher}
                                onClick={this.handleClick}
                            />
                        })}
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default StudentChatDialog;
